var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8230)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8230",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0215 22.9981C46.4906 22.9984 45.9815 23.2093 45.6061 23.5847C45.2307 23.9601 45.0197 24.4692 45.0195 25.0001C45.0195 36.0389 36.0388 45.0196 25 45.0196C13.9612 45.0196 4.98047 36.0389 4.98047 25.0001C4.98047 13.9613 13.9612 4.98057 25 4.98057C27.6422 4.97298 30.2594 5.49205 32.6987 6.50744C35.138 7.52283 37.3505 9.01417 39.2068 10.8943C39.5831 11.2606 40.0881 11.4643 40.6132 11.4617C41.1382 11.4591 41.6412 11.2503 42.0138 10.8803C42.3864 10.5104 42.5987 10.0089 42.605 9.48384C42.6113 8.95883 42.4111 8.45235 42.0476 8.07353C39.82 5.8173 37.1652 4.02764 34.2381 2.80911C31.3111 1.59059 28.1705 0.967635 25 0.976659C11.7531 0.976659 0.976562 11.7532 0.976562 25.0001C0.976562 38.247 11.7531 49.0235 25 49.0235C38.2469 49.0235 49.0234 38.2471 49.0234 25.0001C49.0233 24.4692 48.8123 23.9601 48.4369 23.5847C48.0615 23.2093 47.5524 22.9983 47.0215 22.9981Z",
    fill: "#31E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5723 27.1641C16.9994 27.1641 18.1562 26.0072 18.1562 24.5801C18.1562 23.153 16.9994 21.9961 15.5723 21.9961C14.1452 21.9961 12.9883 23.153 12.9883 24.5801C12.9883 26.0072 14.1452 27.1641 15.5723 27.1641Z",
    fill: "#31E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.502 27.1641C27.929 27.1641 29.0859 26.0072 29.0859 24.5801C29.0859 23.153 27.929 21.9961 26.502 21.9961C25.0749 21.9961 23.918 23.153 23.918 24.5801C23.918 26.0072 25.0749 27.1641 26.502 27.1641Z",
    fill: "#31E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4316 27.1641C38.8587 27.1641 40.0156 26.0072 40.0156 24.5801C40.0156 23.153 38.8587 21.9961 37.4316 21.9961C36.0045 21.9961 34.8477 23.153 34.8477 24.5801C34.8477 26.0072 36.0045 27.1641 37.4316 27.1641Z",
    fill: "#31E5E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingBlue);
export default __webpack_public_path__ + "static/media/pending_blue.5886ede83c162a432d6a22f2bd5e77d4.svg";
export { ForwardRef as ReactComponent };